import { BaseEntityDtoAny } from "@/common/ts/entity";
import { GeneralAttachedTagsDto, TagEntityType } from "@/core/api/generated/v1";

import EntityTagsInfoChip from "../../EntityInfo/EntityTagsInfoChip";
import { defaultTableCellContentOfChipProps } from "./TableCellContentOfChip";

interface Props {
  entityType: TagEntityType;
  entity: Nil<BaseEntityDtoAny>;
  onUpdate: (newTags: Nil<GeneralAttachedTagsDto>) => void;
}

export default function TableCellContentOfTags({ entityType, entity, onUpdate }: Props) {
  return (
    <EntityTagsInfoChip
      entityType={entityType}
      entity={entity}
      noDataPlaceholder='-'
      edit={{
        onSaved: onUpdate,
      }}
      chipProps={defaultTableCellContentOfChipProps}
    />
  );
}
